import React, { Component } from 'react';
import './ChallengeStatement.css';
import InnerHeaderBar from '../../shared/InnerHeaderBar/InnerHeaderBar';
import ChallengeStatementFormFirst from './ChallengeStatementFormFirst/ChallengeStatementFormFirst';
import ChallengeStatementFormSecond from './ChallengeStatementFormSecond/ChallengeStatementFormSecond';
import _ from 'lodash';
import { Link } from 'react-router-dom';

class ChallengeStatement extends Component {
    constructor(props) {
        super(props);
        this.defaultParams = {};
        this.state = {
            horizonSecondRequired: true,
            formValidHorizon1: false,
            formValidHorizon2: true,
            createdData: false,
            editedData: false,
            horizonSecondEdit: false,
            createData: {
                horizon1: {
                    company: '',
                    goal: '',
                    category: '',
                    timeframe: '',
                },
                horizon2: {
                    goal: '',
                    category: '',
                    timeframe: '',
                }
            },
            inputStates: {
                horizon1: {
                    company: false,
                    goal: false,
                    category: false,
                    timeframe: false,
                },
                horizon2: {
                    //company: false,
                    goal: true,
                    category: true,
                    timeframe: true,
                },
            }
        };
    }

    onDataChange = (key, value, valid, type) => {
        const state = _.extend({}, this.state);

        if(type === 'horizon2' && !_.includes(state.createData.horizon2, false)  &&  !this.state.horizonSecondEdit){
            state.horizonSecondRequired = false
            state.inputStates.horizon2.goal = false;
            state.inputStates.horizon2.category = false;
            state.inputStates.horizon2.timeframe = false;
        }

        state.inputStates[type][key] = valid;
        state.createData[type][key] = value;
        this.setState(state, () => this.validateForm(type));

        if(type === 'horizon2'  && this.allValuesFalse(state.createData.horizon2)) {
            state.horizonSecondRequired = false
            state.inputStates.horizon2.goal = true;
            state.inputStates.horizon2.category = true;
            state.inputStates.horizon2.timeframe = true;
        }

        if(type === 'horizon2'  && this.allValuesTrue(state.createData.horizon2)) {
            state.horizonSecondRequired = true;
            state.inputStates.horizon2.goal = true;
            state.inputStates.horizon2.category = true;
            state.inputStates.horizon2.timeframe = true;
        }

    };

    allValuesTrue = (obj) =>{
        for(var o in obj)
            if(!obj[o]) return false;
        return true;
    }

    allValuesFalse = (obj) =>{
        for(var o in obj)
            if(obj[o]) return false;
        return true;
    }

    validateForm = (type) => {

        if(type === 'horizon1'){
            let validationStates = _.extend({}, this.state.inputStates[type]);
            let key = Object.values(validationStates).indexOf(false) !== -1;
            let state = !key;
            this.setState({ formValidHorizon1: state });
        }
        if (type === 'horizon2') {
            let validationStates = _.extend({}, this.state.inputStates[type]);
            let key = Object.values(validationStates).indexOf(false) !== -1;
            let state = !key;
            this.setState({ formValidHorizon2: state });
        }
    }

    componentWillMount() {
        localStorage.setItem("openedTool", this.props.projectId);
        // let id = this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 1];
        let body = {
          projectId: this.props.projectId,
          type: "challenge"
        }
        this.props.getChallengeStatement(body)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.getChallengeStatementData.Items !== this.props.getChallengeStatementData.Items) {
            if (_.isEmpty(nextProps.getChallengeStatementData.Items) && !this.state.createdData) {
                this.setState({ createdData: true, editedData: false });
                for (var i in this.state.createData.horizon1) this.state.createData.horizon1[i] = '';
                for (var i in this.state.createData.horizon2) this.state.createData.horizon2[i] = '';
                for (var i in this.state.inputStates.horizon1) this.state.inputStates.horizon1[i] = false;
                for (var i in this.state.inputStates.horizon2) this.state.inputStates.horizon2[i] = true;

            } else if (!_.isEmpty(nextProps.getChallengeStatementData.Items) && !this.state.editedData) {

                this.setState({ formValidHorizon1: true, formValidHorizon2: true })

                if (nextProps.getChallengeStatementData.Items[0].chalange.horizon1) {
                    let createData = _.extend({}, this.state.createData.horizon1, nextProps.getChallengeStatementData.Items[0].chalange.horizon1);

                    this.defaultParams = _.extend({}, createData);
                    const state = _.extend({}, this.state);
                    state.createData.horizon1 = createData
                    for (var i in this.state.inputStates.horizon1) this.state.inputStates.horizon1[i] = true;
                    this.setState({ editedData: true, createdData: false });
                }

                if (nextProps.getChallengeStatementData.Items[0].chalange.horizon2) {
                    this.setState({ horizonSecondEdit: true })
                    let createData = _.extend({}, this.state.createData.horizon2, nextProps.getChallengeStatementData.Items[0].chalange.horizon2);

                    this.defaultParams = _.extend({}, createData);
                    const state = _.extend({}, this.state);
                    state.createData.horizon2 = createData
                    this.setState({ editedData: true, createdData: false });
                }

            }
        }
    }

    challengeStatementSave = () => {
        let data;
        if (this.state.editedData) {

            if (Object.values(this.state.createData.horizon2).includes('')) {
                data = {
                    id: this.props.getChallengeStatementData.Items[0].id,
                    horizon1: this.state.createData.horizon1
                }
            } else {
                data = {
                    id: this.props.getChallengeStatementData.Items[0].id,
                    horizon1: this.state.createData.horizon1,
                    horizon2: this.state.createData.horizon2
                }
            }
            this.props.nextStep();
            this.props.editChallengeStatement(data);

        } else if (this.state.createdData) {
            if (Object.values(this.state.createData.horizon2).includes('')) {
                data = {
                    type: 'challenge',
                    projectId: this.props.projectId,
                    horizon1: this.state.createData.horizon1,
                    status: 'finished',
                    //horizon2: this.state.createData.horizon2,
                }
            } else {
                data = {
                    type: 'challenge',
                    projectId: this.props.projectId,
                    horizon1: this.state.createData.horizon1,
                    horizon2: this.state.createData.horizon2,
                    status: 'finished',
                }
            }

            this.props.createChallengeStatement(data);
            this.props.nextStep();

        }
    }

    render() {
        return (
            <div className='projects-content challenge-statement-content'>
                <div className='step-bar'>
                    <div className='step step-two arrow-step active-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-two arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className="col-md-12">
                            <h5 style={{ marginBottom: "0px" }}>BUSINESS CHALLENGE STATEMENT</h5>
                            <p><i>Please fill in the items</i></p>
                        </div>
                        <div className='col-sm-6'>
                            <ChallengeStatementFormFirst
                                createData={this.state.createData.horizon1}
                                onDataChange={this.onDataChange}
                            />
                        </div>
                        <div className='col-sm-6'>

                            <ChallengeStatementFormSecond
                                createData={this.state.createData.horizon2}
                                companyName={this.state.createData.horizon1.company}
                                onDataChange={this.onDataChange}
                            />
                        </div>
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className={(this.state.formValidHorizon1 && this.state.formValidHorizon2) ? 'btn btn-success' : 'btn btn-success disabled'} onClick={this.challengeStatementSave} >Next</div>
                                    <Link className='btn empty-btn default' to='/toolkit'> Back </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default (ChallengeStatement);



// WEBPACK FOOTER //
// ./src/components/ChallengeStatement/ChallengeStatement.jsx